<template>
  <div>
    <section>
      <div class="row card-body">
        <div class="col-lg-6 pr-lg-4">
          <div class="d-flex align-items-center justify-content-center">
            <div class="user-avatar">
              <img :src="boxImg" alt="profile image" class="img-fluid" />
            </div>
          </div>
        </div>
        <b-col class="col-lg-6">
          <div class="page-header border-bottom">
            <p class="page-title">{{ $t('box.title') }}</p>
          </div>
          <b-row>
            <div class="col-lg-6">
              <div class="clearfix pb-2">
                <div class="text-muted">{{ $t('box.name') }}</div>
                <span>{{ item.digitalThing.name }}</span>
              </div>
              <div class="clearfix pb-2">
                <div class="text-muted">
                  {{ $t('box.responsibleEmployee') }}
                </div>
                <span>
                  {{
                    responsibleEmployee.fullName
                      ? responsibleEmployee.fullName
                      : $t('box.responsibleNotDefined')
                  }}
                </span>
              </div>
              <div class="clearfix pb-2">
                <div class="text-muted">{{ $t('box.nominalPower') }}</div>
                <span>
                  {{ item.nominalPower ? item.nominalPower : $t('box.notDefinedPower') }}
                </span>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="clearfix pb-2">
                <div class="text-muted">{{ $t('box.object') }}</div>
                <span>{{ item.digitalThing.workCenter.itObject.name }}</span>
              </div>
              <div class="clearfix pb-2">
                <div class="text-muted">{{ $t('box.startDate') }}</div>
                <span>{{ toLocaleDateString(item.startDate) }}</span>
              </div>
              <div class="clearfix pb-2">
                <div class="text-muted">{{ $t('box.boxEquipmentType') }}</div>
                <span>{{ typeName }}</span>
              </div>
            </div>
          </b-row>
          <div>
            <p class="pb-2 text-muted">
              {{ $t('box.targetEfficiency') }}
              <i
                id="targetEfficiencyInfo"
                class="mdi mdi-24px mdi-info mdi-information-outline"
              ></i>
            </p>
            <vue-slider
              v-model="efficiency"
              class="calculated-range"
              disabled
              :min="0"
              dot-size="20"
              :height="8"
              :tooltip="'always'"
            ></vue-slider>
          </div>
          <b-tooltip
            custom-class="info-tooltip"
            target="targetEfficiencyInfo"
            variant="danger"
            :title="$t('box.tooltip.efficiency')"
          ></b-tooltip>
        </b-col>
      </div>
      <div class="col-lg-12">
        <div class="d-block px-3 pb-4">
          <div class="page-header border-bottom">
            <p class="page-title">{{ $t('box.description') }}</p>
          </div>
          <b-form-textarea
            v-model="description"
            class="form-control"
            placeholder="Enter content"
            :rows="3"
            :max-rows="6"
            disabled
          ></b-form-textarea>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import defaultImage from '@/assets/images/KOEEBOX.png';

export default {
  name: 'SettingsBoxCard',
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    efficiency() {
      return this.item &&
        this.item.digitalThing &&
        this.item.digitalThing.workCenter &&
        this.item.digitalThing.workCenter.efficiencyParam &&
        this.item.digitalThing.workCenter.efficiencyParam.targetEfficiency
        ? this.item.digitalThing.workCenter.efficiencyParam.targetEfficiency
        : 0;
    },
    description() {
      return this.item &&
        this.item.digitalThing &&
        this.item.digitalThing.workCenter &&
        this.item.digitalThing.workCenter.comment
        ? this.item.digitalThing.workCenter.comment
        : null;
    },
    typeName() {
      return this.item && this.item.boxEquipmentType == '0'
        ? this.$t('boxEquipmentType.types.continuous')
        : this.$t('boxEquipmentType.types.discrete');
    },
    responsibleEmployee() {
      const responsibleEmployee =
        this.item && this.item.digitalThing.workCenter.responsibleEmployee;
      return responsibleEmployee ? responsibleEmployee : {};
    },
    boxImg() {
      const attachmentImage = this.item && this.item.digitalThing.workCenter.attachmentImage;
      return attachmentImage ? attachmentImage.url : defaultImage;
    },
    efficiencyParam() {
      const efficiencyParam = this.item && this.item.digitalThing.workCenter.efficiencyParam;
      return efficiencyParam ? efficiencyParam : {};
    },
    workCenterId() {
      return this.item && this.item.digitalThing && this.item.digitalThing.workCenter
        ? this.item.digitalThing.workCenter.id
        : null;
    },
  },
  methods: {
    toLocaleDateString(dateStr) {
      return new Date(dateStr).toLocaleDateString();
    },
  },
};
</script>

<style></style>
